export default __webpack_public_path__ + "static/media/meteor-icon.867d2079.svg";